import React, { useEffect } from "react";
import Grid from "@mui/material/Grid2";
import Button from "@mui/material/Button";

import Navigation from "../../Components/Navigation";

import Footer from "../../Components/Footer";
import FFTable from "../../Components/Table2";
import ContactRibbon from "../../Components/ContactRibbon";
import ScrollToTopButton from "../../Components/ScrollTop";
import HeroAlt from "../../Components/HeroAlt";

export default function Comments() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = "Public Comments";
  }, []);
  return (
    <main>
      <Navigation />

      <HeroAlt title="Public Commentary Table" />

      <section>
        <ScrollToTopButton/>
        <Grid
          container
          size={12}
          justifyContent="center"
          padding="2% 0"
          spacing={2}
          backgroundColor="#f4f4f4"
        >
          {/*MEETINGS SECTION */}
          <Grid item size={{ xs: 11, sm: 11, md: 10, lg: 9, xl: 9 }} container>
        
            <Grid size={12} padding="1% 0">
              <p>
                Below, you will find a table that reflects all comments we have
                collected through our series of community listening sessions as
                well as organic comments we have received from our online
                comment form. It includes the comment text, submission date, and
                the targeted area within Eastern Alachua County. The table
                updates in real time, and we encourage you to share your input
                through our comment form. Please note that your identity and
                contact information will not be included in the table.
              </p>
            </Grid>
            <Grid size={{ xs: 12 }}>
              <FFTable />
            </Grid>
          </Grid>
        </Grid>
      </section>
      <section>
        <Grid
          container
          spacing={4}
          size={12}
          justifyContent="center"
          paddingBottom="4%"
          backgroundColor="#f4f4f4"
        ></Grid>
      </section>

      {/* CODE FOR THE CONTACT US RIBBON */}
      <section className="contact-container">
        <ContactRibbon />
      </section>

      <Footer />
    </main>
  );
}
